import { render, staticRenderFns } from "./ServicesAsList.vue?vue&type=template&id=330eb1d3&scoped=true&"
import script from "./ServicesAsList.vue?vue&type=script&lang=js&"
export * from "./ServicesAsList.vue?vue&type=script&lang=js&"
import style0 from "./ServicesAsList.vue?vue&type=style&index=0&id=330eb1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330eb1d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
